import React from 'react';
import {PaymentRequestButtonElement} from '@stripe/react-stripe-js';

const GoogleApplePay = ({paymentRequest}) => {
  return paymentRequest ? <PaymentRequestButtonElement options={{paymentRequest}} /> : <></>
}

export default GoogleApplePay;